// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollCTA__container___3TLjN","prompt":"ScrollCTA__prompt___3y7hR","arrow-icon":"ScrollCTA__arrow-icon___2Xjb7"};